export default __webpack_public_path__ + "a76009b83c7c35aee2e20927a9bcd2cd.png";